import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SR_API_ACTION_PROPERTY_ATTRIBUTE_DELETE } from 'api/actionTypes';

import SrText from 'client/components/SrText';
import SrTable from 'client/components/SrTable';

import postWithState from 'client/actions/postWithState';

class SrTablePropertyAttributeFeature extends Component {
  static propTypes = {
    propertyAttributes: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  _onDeletePropertyAttribute = (e) => {
    const { propertyAttributes, dispatch, onChange } = this.props;
    const propertyAttributeId = parseInt(e.target.dataset.id, 10);
    const propertyAttribute = propertyAttributes.find(({ id }) => id === propertyAttributeId);

    // eslint-disable-next-line max-len
    if (
      !global.confirm(
        `Are you sure you want to delete the property feature \n "${propertyAttribute.attrs.value}"?`,
      )
    ) {
      return;
    }

    dispatch(postWithState, {
      action: SR_API_ACTION_PROPERTY_ATTRIBUTE_DELETE,
      payload: {
        propertyAttributeId,
      },
      onSuccess: onChange,
      onError: (err) => {
        global.alert(`Error: "${err.message}"`);
      },
    });
  };

  render() {
    const { propertyAttributes } = this.props;

    return (
      <SrTable
        headers={[
          { content: 'id' },
          { content: 'apartment id' },
          { content: 'building id' },
          { content: 'floor plan id' },
          { content: 'description' },
          { content: 'options', width: 10 },
        ]}
        rows={propertyAttributes.map((propertyAttribute) => ({
          cells: [
            { content: propertyAttribute.id },
            {
              content:
                !propertyAttribute.apartmentBuildingId && !propertyAttribute.floorPlanId
                  ? propertyAttribute.apartmentId
                  : '',
            },
            { content: propertyAttribute.apartmentBuildingId },
            { content: propertyAttribute.floorPlanId },
            { content: propertyAttribute.attrs.value },
            {
              content: (
                <div>
                  <SrText
                    cursor="pointer"
                    color="blue300"
                    data-id={propertyAttribute.id}
                    onClick={this._onDeletePropertyAttribute}
                  >
                    Delete
                  </SrText>
                </div>
              ),
            },
          ],
        }))}
      />
    );
  }
}

SrTablePropertyAttributeFeature.displayName = 'SrTablePropertyAttributeFeature';

export default SrTablePropertyAttributeFeature;
